import z from "zod";
import { bookableOrderItemStatusZodSchema } from "./bookable-order-item-status";
import { buyableOrderItemStatusZodSchema } from "./buyable-order-item-status";

const orderItemStatusZodSchema = z.union([
    bookableOrderItemStatusZodSchema,
    buyableOrderItemStatusZodSchema,
]);

type OrderItemStatus = z.infer<typeof orderItemStatusZodSchema>;

export { orderItemStatusZodSchema };
export type { OrderItemStatus };
